import { useEffect, useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'

const EDGE =
  (import.meta.env.VITE_SUPABASE_URL || '').replace(/\/$/, '') + '/functions/v1/simple-hq-leave-action'

/** Email one-tap leave approve/deny — redirects to edge GET (works without login). */
export function LeaveEmailActionPage() {
  const [params] = useSearchParams()
  const token = params.get('token') || ''
  const decision = (params.get('decision') || '').toLowerCase()
  const [message, setMessage] = useState('Redirecting to approve…')

  useEffect(() => {
    if (!token || (decision !== 'approved' && decision !== 'denied')) {
      setMessage('Invalid approval link.')
      return
    }
    if (!EDGE.startsWith('http')) {
      setMessage('App is missing Supabase URL configuration.')
      return
    }
    const url = `${EDGE}?token=${encodeURIComponent(token)}&decision=${encodeURIComponent(decision)}`
    window.location.replace(url)
  }, [token, decision])

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#f7f9fb] px-4">
      <div className="max-w-md w-full bg-white border border-[#d8e0e8] rounded-lg p-6 text-center">
        <h1 className="text-xl font-bold mb-2">Simple HQ</h1>
        <p className="text-slate-700">{message}</p>
        <Link to="/simple-hq" className="inline-block mt-4 text-teal-800 font-semibold">
          Open Simple HQ
        </Link>
      </div>
    </div>
  )
}
